import React, { ReactNode, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { State } from '../reducers'
import { logNavigation } from '../lib/bugsnag-breadcrumbs'

export const Wrapper = ({ children }: { children: ReactNode }) => {
    const reduxSearchParams = useSelector<State, string>((state) => state.user.search_params)
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const previousPathnameRef = useRef<string>()

    useEffect(() => {
        navigate(reduxSearchParams ? `?${reduxSearchParams}` : ``, { replace: true })
    }, [pathname, reduxSearchParams])

    // Log navigation breadcrumbs for Bugsnag
    useEffect(() => {
        if (previousPathnameRef.current && previousPathnameRef.current !== pathname) {
            logNavigation(previousPathnameRef.current, pathname)
        }
        previousPathnameRef.current = pathname
    }, [pathname])

    return <div className="flex w-full">{children}</div>
}
